"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ComponentWrapper = _interopRequireDefault(require("../../../../helpers/ComponentWrapper"));
var QDContactUs = function QDContactUs() {
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    className: "max-width-xxs text-center"
  }, /*#__PURE__*/_react["default"].createElement("h3", null, "UK Office"), /*#__PURE__*/_react["default"].createElement("p", null, "Quarterdeck,5th Floor", /*#__PURE__*/_react["default"].createElement("br", null), "The Office Group, 133 Whitechapel High St,", /*#__PURE__*/_react["default"].createElement("br", null), "London E1 7QA"), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("h3", null, "Company Registered at"), /*#__PURE__*/_react["default"].createElement("p", null, "Quarterdeck Life Ltd, 5th Floor, The Office Group, 133 Whitechapel High St, London E1 7QA."));
};
var _default = exports["default"] = QDContactUs;